import { NgModule } from '@angular/core';
import { RouterModule, Routes, NoPreloading } from '@angular/router';
import { authGuardFn } from '@auth0/auth0-angular';
import { roleGuardFn, PermissionRequirements } from './guards/role.guard';
import { PermissionNames } from './modules/admin/models/permission-names';

const routes: Routes = [
    {
        path: 'dashboard',
        loadChildren: () =>
            import('./modules/rail-performance/rail-performance.module').then((m) => m.RailPerformanceModule),
        canActivate: [authGuardFn, roleGuardFn],
        data: { requiredPermissions: PermissionRequirements.all([PermissionNames.RailPerformance.Read]) }
    },
    {
        path: "forecast",
        loadChildren: () =>
            import('./routes/forecast/forecast.module').then((m) => m.ForecastModule),
        canActivate: [authGuardFn, roleGuardFn],
        data: { requiredPermissions: PermissionRequirements.all([ PermissionNames.ForecastDemand.Read ]) }
    },
    {
        path: 'forecast-demand',
        loadChildren: () =>
            import('./modules/forecast-demand/forecast-demand.module').then((m) => m.ForecastDemandModule),
        canActivate: [authGuardFn, roleGuardFn],
        data: { requiredPermissions: PermissionRequirements.all([ PermissionNames.ForecastDemand.Read ]) }
    },
    {
        path: 'support-center',
        loadChildren: () =>
            import('./modules/support-center/support-center.module').then((m) => m.SupportCenterModule),
        canActivate: [authGuardFn, roleGuardFn],
        data: {
            requiredPermissions: PermissionRequirements.any([
                PermissionNames.ForecastDemand.KnowledgeBase.Read,
                PermissionNames.RailImpact.KnowledgeBase.Read,
                PermissionNames.RailPerformance.KnowledgeBase.Read
            ])
        }
    },
    {
        path: 'platform-management',
        loadChildren: () =>
            import('./modules/platform-management/platform-management.module').then((m) => m.PlatformManagementModule),
        canActivate: [authGuardFn, roleGuardFn],
        data: {
            requiredPermissions: PermissionRequirements.any([
                PermissionNames.PlatformManagement.Tenants.Read,
                PermissionNames.PlatformManagement.Users.Read,
                PermissionNames.PlatformManagement.Roles.Read,
                PermissionNames.PlatformManagement.Permissions.Read
            ])
        }
    },
    { path: "**", redirectTo: "dashboard" }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        bindToComponentInputs: true,
        paramsInheritanceStrategy: 'always',
        preloadingStrategy: NoPreloading
    })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
